/** IANA time zone names for pickers (ACRE panel time zone, #53). */

/** The runtime's IANA zone list (`Intl.supportedValuesOf`, ES2022 -- typed
 *  loosely because the project's TS lib is ES2020), plus UTC, sorted. Empty
 *  where the runtime lacks the API: the field then stays free text and the
 *  server validates it. */
export function timeZoneNames(): string[] {
  const intl = Intl as unknown as { supportedValuesOf?: (key: string) => string[] }
  let names: string[] = []
  try {
    names = intl.supportedValuesOf?.('timeZone') ?? []
  } catch {
    names = []
  }
  return Array.from(new Set([...names, 'UTC'])).sort()
}

/** The input with its canonical casing when it matches a known zone
 *  case-insensitively ("europe/oslo" -> "Europe/Oslo"), else trimmed as typed.
 *  The server accepts exact IANA names only, so this keeps a casing slip from
 *  turning into a 422 while anything unknown still reaches its validation. */
export function canonicalTimeZone(input: string, known: readonly string[] = timeZoneNames()): string {
  const value = input.trim()
  if (!value) return ''
  const lower = value.toLowerCase()
  return known.find((name) => name.toLowerCase() === lower) ?? value
}
